import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Platform", path: "/platform" },
  { label: "Security", path: "/security" },
  { label: "Case Studies", path: "/case-studies" },
  { label: "About Us", path: "/about" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
   <header className="absolute top-4 left-0 right-0 z-50 px-6 md:px-12" data-testid="navbar">
      <nav className="nav-pill max-w-7xl mx-auto px-6 flex items-center justify-between h-14">
        {/* Logo */}
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img src="/assets/horizontal-white-logo.svg" alt="Compu.J" className="h-6 w-auto" />
        </Link>

        {/* Desktop Links - Center */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm transition-colors duration-200 ${
                location.pathname === link.path ? "text-white" : "text-[#A1A1AA] hover:text-white"
              }`}
              style={{ fontFamily: "'Lora', serif" }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Right side */}
        <div className="flex items-center gap-3">
          {/* Book Demo - Desktop */}
          <Link
            to="/contact"
            data-testid="nav-book-demo-btn"
            className="hidden md:inline-flex cta-gradient text-sm font-medium px-5 py-2 rounded-full"
            style={{ fontFamily: "'Lora', serif" }}
          >
            Book Demo
          </Link>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle mobile menu"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="nav-pill max-w-7xl mx-auto mt-2 px-6 pb-6 pt-2" data-testid="mobile-menu">
          <div className="border-t border-white/10 pt-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className="block py-3 text-sm text-[#A1A1AA] hover:text-white transition-colors"
                style={{ fontFamily: "'Lora', serif" }}
              >
                {link.label}
              </Link>
            ))}

            <Link
              to="/contact"
              onClick={() => setMobileOpen(false)}
              className="cta-gradient block text-center text-sm font-medium px-5 py-2 rounded-full mt-3"
              style={{ fontFamily: "'Lora', serif" }}
            >
              Book Demo
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}